<script setup lang="ts">
import type { CashDrawer } from '../../../types';

defineEmits<{
  onChange: [];
}>();

defineProps<{
  cashDrawerError: boolean | string;
  cashDrawerOptions: CashDrawer[];
  loading: boolean;
}>();

const model = defineModel<CashDrawer | null>();
</script>

<template>
  <div class="flex max-w-[500px] flex-col gap-1">
    <AFieldLabel
      required
      :error="cashDrawerError"
      :label="$t('cart.label.cashDrawer')"
    />

    <AFieldDropdown
      v-model="model"
      optionLabel="label"
      :disabled="loading"
      :error="cashDrawerError"
      :hasFilter="cashDrawerOptions.length > 5"
      :options="cashDrawerOptions"
      @change="$emit('onChange')"
    />
  </div>
</template>
